import { Offcanvas } from "react-bootstrap";
import { BinIcon } from "../../../../components/icon/Icon";
import {
    CashierWrapperBackSliderStyled,
    CashierWrapperHeaderStyled,
    CashierWrapperSliderHeaderStyled,
    CashierWrapperStyled
} from "./styled/CashierWrapperStyled";

function CashierWrapper(props) {
    const {children, handleClose, isSlider, show, title, sliderTitle} = props;

    return isSlider ? <Offcanvas show={show} placement="end" style={{width: "100%"}}>
            <CashierWrapperSliderHeaderStyled>
                <CashierWrapperBackSliderStyled onClick={handleClose}>
                    <BinIcon name={'IcBack'}/>
                </CashierWrapperBackSliderStyled>
                <span>{sliderTitle}</span>
            </CashierWrapperSliderHeaderStyled>
            {children}
        </Offcanvas>
        :
        !!show && <CashierWrapperStyled>
            <CashierWrapperHeaderStyled>
                <div onClick={handleClose}>
                    <BinIcon name={'IcBack'}/>
                </div>
                <span className={'ms-3'}>{title}</span>
            </CashierWrapperHeaderStyled>
            {children}
        </CashierWrapperStyled>
}

export default CashierWrapper;
